import {
	createFormHook,
	createFormHookContexts,
	FormValidateAsyncFn,
} from '@tanstack/react-form';

import { PageStepper } from './components/PageStepper';
import {
	MultiAutocompleteInput,
	SingleAutocompleteInput,
} from './inputs/AutocompleteInput';
import { BooleanInput } from './inputs/BooleanInput';
import { CATCodeInput } from './inputs/CATCodeInput';
import { CauseOfLossCodeInput } from './inputs/CauseOfLossCodeInput';
import { DateOfLossInput } from './inputs/DateOfLossInput';
import { IndustryInput } from './inputs/IndustryInput';
import { PhoneInput } from './inputs/PhoneInput';
import { SelectInput } from './inputs/SelectInput';
import { TextInput } from './inputs/TextInput';
import { TimeInput } from './inputs/TimeInput';
import { ToggleInput } from './inputs/ToggleInput';

export const { fieldContext, useFieldContext, formContext, useFormContext } =
	createFormHookContexts();

// NOTE - if you add a new input here, make sure to export it in `packages/features/src/types.ts` as well
export const inputs = {
	BooleanInput,
	PhoneInput,
	MultiAutocompleteInput,
	SelectInput,
	SingleAutocompleteInput,
	TextInput,
	TimeInput,
	ToggleInput,
	IndustryInput,
	CATCodeInput,
	CauseOfLossCodeInput,
	DateOfLossInput,
};

export const { useAppForm, withForm } = createFormHook({
	fieldComponents: inputs,
	formComponents: {
		PageStepper,
	},
	fieldContext,
	formContext,
});

export type Validation = Promise<
	{ fields: { [k: string]: string } } | string | null
>;

export const formOpts = <T>(): {
	defaultValues: T;
	validators: {
		onSubmitAsync: (arg: Parameters<FormValidateAsyncFn<T>>[0]) => Validation;
	};
} => ({
	defaultValues: {} as T,
	validators: {
		onSubmitAsync: (_) => Promise.resolve(null),
	},
});
